/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-22T13:39:18+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-05T11:04:59+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  isBetweenDates,
  isEqualDate,
  getWeekArray,
  addYears,
} from './dateUtils';
import AButtonDay from './AButtonDay';

/**
 * MMonthCalendar - …
 */
class MMonthCalendar extends Component {
  /**
     * react render() <MMonthCalendar>
     *
     * @return {object}
     */
  render() {
    return (
      <div className="m-month m-month-calendar">
        {this.getWeekElements()}
      </div>
    );
  }

    /**
     * @param {date} date
     * @param {object} event
     */
    handlePressDay = (date, event) => {
      if (this.props.onPressDay) this.props.onPressDay(date, event);
    };

    /**
     * check if current date should be considered "disabled"
     *
     * @return {boolean}
     */
    isSelectedDateDisabled() {
      return this.selectedDateDisabled;
    }

    /**
     * check for single day if it is allowed or not allowed to be selected
     *
     * @param {date} day
     * @return {boolean}
     */
    shouldDisableDate(day) {
      if (day === null) return false;
      let disabled = !isBetweenDates(day, this.props.minDate, this.props.maxDate);
      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);

      return disabled;
    }

    /**
     * do transform a weekArray from a utils function and
     * return as a set of react objects inside array
     *
     * @return {array}
     */
    getWeekElements() {
      const weekArray = getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);
      return weekArray.map((week, i) => {
        return (
          <div key={i} className="m-month-calendar__week">
            {this.getDayElements(week, i)}
          </div>
        );
      }, this);
    }

    /**
     * renders a weeArray from a utils function into react object inside array
     *
     * @param {object} week
     * @param {number} i
     * @return {array}
     */
    getDayElements(week, i) {
      return week.map((day, j) => {
        const isSameDate = isEqualDate(this.props.selectedDate, day);
        const disabled = this.shouldDisableDate(day);
        const selected = !disabled && isSameDate;

        if (isSameDate) {
          this.selectedDateDisabled = disabled;
        }

        return (
          <AButtonDay
            date={day}
            disabled={disabled}
            key={`db${(i + j)}`}
            onPress={this.handlePressDay}
            active={selected}
          />
        );
      }, this);
    }
}
MMonthCalendar.propTypes = {
  // autoOk: PropTypes.bool,
  displayDate: PropTypes.object.isRequired,
  firstDayOfWeek: PropTypes.number,
  maxDate: PropTypes.object,
  minDate: PropTypes.object,
  /**
     * passes (date, event)
     * @type {Function}
     */
  onPressDay: PropTypes.func,
  selectedDate: PropTypes.object.isRequired,
  shouldDisableDate: PropTypes.func,
};
MMonthCalendar.defaultProps = {
  firstDayOfWeek: 1,
  displayDate: new Date(),
  selectedDate: new Date(),
  minDate: addYears(new Date(), -100),
  maxDate: addYears(new Date(), 100),
};
export default MMonthCalendar;

